import { isObject } from "lodash";
import { VariantName } from "../../Itinerary/objects/circuit";
import { TripVersion } from "../../Menu/MaterialTripList/objects/tripVersion"
import { User } from "../../Menu/MaterialTripList/objects/user"

type Options = {
    rootData: unknown,
    user: User | null,
}

export function filterVersionsAndVariants(options: Options): unknown {
    const versions = (
        options.rootData as unknown as { data: TripVersion[] } | null
    )?.data ?? (
        options.rootData as unknown as { trip: { data: TripVersion[] } | null } | null
    )?.trip?.data;
    const variants = (
        options.rootData as unknown as { variant_name: VariantName[] } | null
    )?.variant_name;

    if (isObject(options.rootData)) {
        return {
            ...options.rootData,
            trip: 'trip' in options.rootData && isObject(options.rootData.trip) ?
                {
                    ...options.rootData.trip,
                    data: versions?.filter((version) => {
                        if (version.visibility === 'PRIVATE') {
                            return false;
                        }
                        if (
                            version.visibility === 'PRIVATE_TO' &&
                            options.user?.client_full?.type === 2
                        ) {
                            return false;
                        }
                        return true;
                    }),
                } :
                undefined,
            data: versions?.filter((version) => {
                if (version.visibility === 'PRIVATE') {
                    return false;
                }
                if (
                    version.visibility === 'PRIVATE_TO' &&
                    options.user?.client_full?.type === 2
                ) {
                    return false;
                }
                return true;
            }),
            variant_name: variants?.filter((variant) => {
                if (variant.visibility === 'PRIVATE') {
                    return false;
                }
                if (
                    variant.visibility === 'PRIVATE_TO' &&
                    options.user?.client_full?.type === 2
                ) {
                    return false;
                }
                return true;
            }),
        }
    }
}